/* Normcore footer: accordion on narrow screens (columns from 750px are pure CSS) and the cookie-settings button. */
(function () {
  if (window.customElements && !customElements.get('nc-footer-accordions')) {
    class NcFooterAccordions extends HTMLElement {
      connectedCallback() {
        this.dataset.js = ''; // CSS collapses the panels only once the script runs; from 750px they are always open
        this.querySelectorAll('.nc-footer__toggle').forEach((btn) => {
          const panel = document.getElementById(btn.getAttribute('aria-controls'));
          if (!panel) return;
          btn.addEventListener('click', () => {
            const open = btn.getAttribute('aria-expanded') !== 'true';
            btn.setAttribute('aria-expanded', String(open));
            panel.classList.toggle('is-open', open);
          });
        });
      }
    }
    customElements.define('nc-footer-accordions', NcFooterAccordions);
  }

  document.addEventListener('click', (event) => {
    const btn = event.target.closest && event.target.closest('[data-nc-cookie-settings]');
    if (!btn) return;
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.showPreferences === 'function') {
      privacy.showPreferences();
    } else if (btn.dataset.fallbackUrl) {
      window.location.href = btn.dataset.fallbackUrl;
    }
  });
})();
